/* ═══════════════════════════════════════════════════════════════
   REVIEW — the seam to the sync feed service, plus the two small
   per-device stores Review keeps in user prefs.
   ═══════════════════════════════════════════════════════════════ */

import { Prefs } from '../services/prefsService';
import type { AppliedMarker } from './finishGuard';
import type { ReminderDismissal } from './types';

export { SyncService as syncService } from '../services/syncService';

/* ─── The reminder's "Don't show again" (user_prefs, per target) ─── */

export function reminderPrefKey(targetId: string): string {
  return `sync.reminder:${targetId}`;
}

export function readReminderDismissal(targetId: string): ReminderDismissal | null {
  const v = Prefs.get(reminderPrefKey(targetId)) as unknown;
  if (v && typeof v === 'object' && typeof (v as ReminderDismissal).rowId === 'string') {
    return v as ReminderDismissal;
  }
  return null;
}

/* ─── Finish's "already applied locally" marker (idempotent Finish) ─── */

export function appliedPrefKey(rowId: string): string {
  return `sync.applied:${rowId}`;
}

export function readAppliedMarker(rowId: string): AppliedMarker | null {
  const v = Prefs.get(appliedPrefKey(rowId)) as unknown;
  if (v && typeof v === 'object' && typeof (v as AppliedMarker).hash === 'string') {
    return v as AppliedMarker;
  }
  return null;
}

export function writeAppliedMarker(rowId: string, marker: AppliedMarker | null): void {
  Prefs.set(appliedPrefKey(rowId), marker);
}

export function writeReminderDismissal(targetId: string, rowId: string): void {
  Prefs.set(reminderPrefKey(targetId), { rowId } satisfies ReminderDismissal);
}
